import React, { useState, useEffect } from 'react';
import { Utilities } from '../../../MedicareProAPI/Utilities/Utilities';

import * as Chartist from 'chartist';

export default function BarChart(props) {
  const newChartId = 'chart-' + Math.floor(Math.random() * 100000);
  const elementProps = { className: props.className || undefined };

  elementProps.sx = { border: '1px solid #000' };

  const defaultChartOptions = {
    width: props.data.labels.length * 90 + 'px',
    axisX: {
      showGrid: false,
    },
    axisY: {
      offset: 0,
    },
  };

  const [chart, setChart] = useState(null);
  const [chartId, setChartId] = useState(newChartId);

  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  });

  useEffect(() => {
    const wrapper = document.getElementById(chartId);
    if (chart && wrapper) {
      chart.detach();
      wrapper.innerHTML = '';
    }

    let barIndex = 0; // <-- manually track index

    const newChart = new Chartist.BarChart(
      '#' + chartId,
      props.data || undefined,
      props.options
        ? Utilities.merge(defaultChartOptions, props.options)
        : { ...defaultChartOptions },
      props.responsiveOptions || undefined
    );

    newChart.on('draw', (data) => {
      if (data.type === 'bar') {
        const barHorizontalCenter = data.x1 + data.element.width() * 0.5;
        const barVerticalCenter = data.y1 + data.element.height() * -1 - 5;
        const value = data.element.attr('ct:value');

        if (value !== 0) {
          const label = new Chartist.Svg('text');
          label.text(props.currency === true ? formatter.format(value) : value);
          label.addClass('ct-renewalByCompany ct-label ct-vertical');
          label.attr({
            x: barHorizontalCenter,
            y: barVerticalCenter,
            'text-anchor': 'middle',
          });
          data.group.append(label);
        }

        if (props.onBarClick) {
          const labelIndex = barIndex++;
          const label = props.data.labels[labelIndex];

          const node = data.element._node;
          node.setAttribute('data-index', labelIndex);
          node.style.cursor = 'pointer';

          node.addEventListener('click', () => {
            if (props.onBarClick) {
              props.onBarClick(label, labelIndex);
            }
          });
        }
      }
    });

    setChart(newChart);
  }, [props.data, props.options, props.responsiveOptions]);

  return (
    chartId && (
      <div className="chart-wrapper">
        <div {...elementProps} id={chartId} />
      </div>
    )
  );
}
